import styled from 'styled-components'

// Wrapper
export const TitlePageWrapper = styled.div`
  /* Parent
  ------------------------------- */
  /* Childrens
  ------------------------------- */
  /* Modifiers
  ------------------------------- */
  &.is-year-warranty {
    .grid-base {
      .grid-container-base {
        @media (max-width: 1279px) {
          justify-content: center;
        }
      }
    }
  }

  /* Media queries
  ------------------------------- */
`
